import React from 'react';
import { StarIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'Este ebook me salvó de la culpa y me dio permiso para cuidarme.',
    name: 'Carla G.'
  }, {
    quote: 'Es como tener una doula emocional en el celular.',
    name: 'Laura P.'
  }, {
    quote: 'Lo leí embarazada, y fue el mejor regalo que me hice.',
    name: 'Daniela R.'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-231">
      <div className="max-w-6xl mx-auto" data-id="element-232">
        <h2 className="text-3xl font-serif font-medium text-center text-[#444] mb-4" data-id="element-233">
          Lo que otras mamás dicen
        </h2>
        <p className="text-center text-[#5a5553] mb-12" data-id="element-234">
          Ya más de 1.200 mamás tomaron este primer paso. Y empezaron a regresar
          a sí mismas.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-235">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#f8f2ee] p-6 rounded-lg" data-id="element-236">
              <div className="flex mb-4" data-id="element-237">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className="text-[#d4b7a8] fill-[#d4b7a8]" data-id="element-238" />)}
              </div>
              <p className="text-[#5a5553] italic mb-4" data-id="element-239">
                "{testimonial.quote}"
              </p>
              <p className="text-[#8e7f7a] font-medium" data-id="element-240">– {testimonial.name}</p>
            </div>)}
        </div>
        <div className="mt-12 bg-[#faf7f5] p-6 rounded-lg" data-id="element-241">
          <h3 className="text-xl font-medium text-[#444] mb-4" data-id="element-242">
            ❓"¿Y si no tengo tiempo?"
          </h3>
          <p className="text-[#5a5553]" data-id="element-243">
            Este ebook es precisamente para eso. Porque si esperas a tener
            tiempo… quizá sea demasiado tarde. El momento no es cuando puedas.
            Es ahora.
          </p>
          <h3 className="text-xl font-medium text-[#444] mt-6 mb-4" data-id="element-244">
            🌱 Y ahora…
          </h3>
          <p className="text-[#5a5553]" data-id="element-245">
            Algo dentro de ti ya sabe lo que tiene que hacer. Ese suspiro que
            acabas de dar, es tu cuerpo diciendo sí.
          </p>
          <p className="text-[#5a5553] mt-2" data-id="element-246">Hazle caso.</p>
        </div>
      </div>
    </section>;
};